import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { DocumentType } from '../../../reference-data.api';

interface BuildDocumentTypeColumnsArgs {
  onEdit: (row: DocumentType) => void;
  onDeactivate: (row: DocumentType) => Promise<void>;
  onReactivate: (row: DocumentType) => Promise<void>;
}

const APPLIES_TO_LABEL: Record<DocumentType['appliesTo'], string> = { truck: 'Truck', trailer: 'Trailer', driver: 'Driver' };

export function buildDocumentTypeColumns({ onEdit, onDeactivate, onReactivate }: BuildDocumentTypeColumnsArgs): TableColumnsType<DocumentType> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Applies to', dataIndex: 'appliesTo', key: 'appliesTo', render: (appliesTo: DocumentType['appliesTo']) => APPLIES_TO_LABEL[appliesTo] },
    {
      title: 'Legal hard block',
      dataIndex: 'legalHardBlock',
      key: 'legalHardBlock',
      render: (value: boolean) => (value ? <Tag color="error">Yes</Tag> : <Tag>No</Tag>),
    },
    {
      title: 'Cross-border only',
      dataIndex: 'crossBorderOnly',
      key: 'crossBorderOnly',
      render: (value: boolean) => (value ? <Tag color="warning">Yes</Tag> : <Tag>No</Tag>),
    },
    { title: 'Typical validity (days)', dataIndex: 'typicalValidityDays', key: 'typicalValidityDays' },
    { title: 'Reminder lead (days)', dataIndex: 'reminderLeadDays', key: 'reminderLeadDays' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
